var Finder = {
    isLoading: false,
    getLastUpdatedBadges: function () {
        if (!Finder.isLoading) {
            Finder.isLoading = true;
            var container = document.getElementById("finder_uploadedBadges");
            container.innerHTML = `
                Cargando contenido...
            `;
            GatewayAPI.get("finder/v1/badges?limit=15&page=1", {}, (r) => {
                var ui = "";

                if (r.success) {
                    r.data.map((badge) => {
                        ui += `
                            <a href="/extras/badges" class="item-container downy d-flex justify-content-center align-items-center" style="" rel="tooltip" data-name="${badge.code}" data-description="Encontrada el ${badge.createdAt}">
                                <img loading="lazy" src="https://images.habbo.com/c_images/album1584/${badge.code}.png" alt="${badge.code}" />
                            </a>
                        `;
                    });

                    container.innerHTML = ui;
                }
            });
            Finder.isLoading = false;
        }
    },
};
